<template>
	<div>
		<!-- h5版本 -->
		<div class="programme-index-mobile" id="solution">
			<div class="title">{{ title }}</div>
			<div class="btn-info" data-wow-delay="100ms">
				<div class="btn-con">
					<div v-for="(item, index) in btnList" @click="selectBar(index)" :class="['item', actIndex == index ? 'active' : '']" :key="index">
						<div class="text">{{item.name}}</div>
					</div>
				</div>
			</div>
			<div v-for="(item, index) in solutionList" :key="index" :class="['solution-item', 'fadeIn', actIndex == index ? 'solution-item-active' : '']">
				<div class="img-wrap">
					<img class="img" :src="item.mobileImgSrc" />
				</div>
				<div class="name">{{ item.title }}</div>
				<div class="content">{{ item.des }}</div>
				<a :href="item.href" class="get-info" target="_blank">了解详情</a>
			</div>
		</div>
	</div>
</template>

<script>
export default {
  props: {
	title: String,
    solutionList: Array,
	btnList: Array,
  },
  data() {
    return {
      actIndex: 0,
    }
  },
  mounted() {
    const that = this
    // console.info(swiper)
  },
  methods: {
    // 选中tab
    selectBar(index) {
      if (this.actIndex !== index) {
        this.actIndex = index
        console.log('this.mySwiper', this.mySwiper)
        // this.mySwiper.slideTo(index, 1000, false)
      }
    },
  },
}
</script>

<style lang="less" scoped>
	.programme-index {
		display: none;
	}
	.programme-index-mobile {
		background-color: #fff;
		padding-top: 1.0667rem;
		padding-bottom: 1.0667rem;
		.title {
			font-size: .5867rem;
			font-family: PingFangSC-Medium, PingFang SC;
			font-weight: 500;
			color: #000000;
			line-height: .5867rem;
			text-align: center;
		}
		.btn-info {
			margin-top: 1.0667rem;
			padding-left: .4rem;
			border-bottom: 1px solid #EEEEEE;
			width: 100%;
			overflow: auto;
			white-space: nowrap;
			.btn-con {
				width: auto;
			}
			.item {
				display: inline-block;
				vertical-align: middle;
				font-size: .48rem;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #202640;
				line-height: .6667rem;
				margin-right: .8rem;
				padding-bottom: .2667rem;
				
			}
			.active {
				position: relative;
				&::after {
					content: '';
					position: absolute;
					width: 1.7067rem;
					height: .08rem;
					background: #E61717;
					left: 0;
					bottom: 0;
				}
			}
		}
		.solution-item {
			display: none;
			.img-wrap {
				padding: .64rem 0.4rem;
				background-color: #FAFAFC;
				.img {
					width: 100%;
					height: 4.88rem;
				}
			}
			.name {
				font-size: .48rem;
				font-family: PingFangSC-Medium, PingFang SC;
				font-weight: 500;
				color: #202640;
				line-height: .6667rem;
				margin-top: .8rem;
				padding: 0 0.4rem;
			}
			.content {
				margin-top: .2667rem;
				font-size: .3733rem;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #202640;
				line-height: .64rem;
				padding: 0 0.4rem;
			}
			.get-info {
				display: inline-block;
				margin-top: .5333rem;
				width: 2.4rem;
				font-size: .3733rem;
				font-family: PingFangSC-Regular, PingFang SC;
				font-weight: 400;
				color: #E61717;
				line-height: .5333rem;
				padding-right: .5867rem;
				background: url('../../../../assets/images/get-info-jiantou.png') no-repeat right center;
				background-size: auto;
				padding: 0 0.4rem;
				}
		}
		.solution-item-active {
			display: block;
		}
	}
</style>
